export class Config {
  public redirectOnError: boolean = true;
  public apiUrl: string;
  public authUrl: string;
  public v1Url: string;
  public liveUrl: string;
  public tokenStorageKey: string;
  public isLocal: boolean = false;
  public sentryUrl: string | undefined;
  public context: string;
  public environment: string;
  public posthogKey?: string;
  public urlPosthog?: string;
  public helpDeskUrl?: string;
}

export enum EnvironmentEnum {
  local = 'local',
  development = 'development',
  staging = 'staging',
  production = 'production',
}
